<template>
  <div class="index-page">
    <div class="block1">
      <div class="banner-wrap" v-if="bannerList.length > 0">
        <swiper :options="swiperOptions">
          <!-- slides -->
          <swiper-slide v-for="(item, index) in bannerList" :key="index">
            <img
              class="banner-img"
              :src="item.imageUrl"
              @click="goto(item.route)"
            />
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div
        class="hot-people-wrap"
        @mouseenter="bagMouseEnter(1)"
        @mouseleave="bagMouseleave(1)"
      >
        <div class="title">
          <div class="icon"></div>
          <div class="font">热门大咖</div>
        </div>
        <swiper :options="swiperOptionsHot" ref="swiperHot">
          <!-- slides -->
          <swiper-slide
            v-for="(firstItem, firstIndex) in getNumber(hotLecturers.length, 6)"
            :key="firstIndex"
          >
            <div class="content">
              <div
                class="people"
                v-for="item in hotLecturers.slice(
                  0 + 6 * firstIndex,
                  6 + 6 * firstIndex
                )"
                :key="item.authorId"
                @click="goto(`/author/${item.authorId}`)"
              >
                <div
                  class="head"
                  :style="{ backgroundImage: `url(${item.headPic})` }"
                ></div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <div class="block2">
      <div class="gold-pointing-wrap">
        <div class="title">
          <div class="left">
            <div class="icon"></div>
            <div class="font">点金</div>
          </div>
          <div class="right" @click="goto('/dianjin')">
            更多
            <div class="arrow"></div>
          </div>
        </div>
        <div class="content">
          <div class="headline-wrap" v-if="headList.length > 0">
            <div class="sub-title">
              <div class="line"></div>
              <div class="font">每日头条</div>
            </div>
            <div
              class="headline"
              v-for="(item, index) in headList"
              :key="index"
              @click="goto(item.route)"
            >
              <div
                class="img"
                v-if="item.imageUrl"
                :style="{ backgroundImage: `url(${item.imageUrl})` }"
              ></div>
              <div class="font">{{ item.title }}</div>
            </div>
          </div>
          <div class="solution-plate-wrap">
            <div class="sub-title">
              <div class="line"></div>
              <div class="font">实时解盘</div>
            </div>
            <div class="solution-plate">
              <div
                v-for="(item, index) in dianJinList"
                :key="index"
                @click="goto(`/dianjin/${item.dianJinInfo.id}`)"
              >
                <div class="dot"></div>
                <div class="time">
                  {{
                    dayjs(item.dianJinInfo.publishTime).format('MM-DD HH:mm')
                  }}
                </div>
                <div class="font">
                  {{
                    (item.authorInfo ? item.authorInfo.name + ' : ' : '') +
                    item.dianJinInfo.title
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hot-course-wrap">
        <div class="title">
          <div class="left">
            <div class="icon"></div>
            <div class="font">热门课程</div>
          </div>
          <div class="right" @click="goto('/course')">
            更多
            <div class="arrow"></div>
          </div>
        </div>
        <ul>
          <li
            class="hot-course"
            v-for="(item, index) in courseList"
            :key="index"
            @click="goto(`/course/${item.setId}`)"
          >
            <div
              class="head"
              :style="{ backgroundImage: `url(${item.coverImagUrl})` }"
            ></div>
            <div class="hot-course-right">
              <div class="name">{{ item.title }}</div>
              <div class="order-info">
                <span class="price">¥{{ item.price }}/套</span>
                <span class="count">{{ item.saledCount }}人购买</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <EveryBanner class="block3" codes="pc_home_middle"></EveryBanner>
    <div
      class="block4"
      @mouseenter="bagMouseEnter(2)"
      @mouseleave="bagMouseleave(2)"
    >
      <!-- 锦囊 -->
      <div class="silk-bag-wrap">
        <div class="title">
          <div class="left">
            <div class="icon"></div>
            <div class="font">锦囊</div>
          </div>
          <div class="right" @click="goto('/jinNang')">
            更多
            <div class="arrow"></div>
          </div>
        </div>
        <swiper ref="mySwiper" :options="swiperOptionsBag">
          <swiper-slide
            v-for="(firstItem, firstIndex) in getNumber(silkBagList.length, 4)"
            :key="firstIndex"
          >
            <div class="content">
              <div
                class="silk-bag"
                v-for="(item, index) in silkBagList.slice(
                  0 + 4 * firstIndex,
                  4 + 4 * firstIndex
                )"
                :key="index"
                @click="goto(`/jinNang/${item.jinNangId}`)"
              >
                <div class="left">
                  <div class="font">总收益</div>
                  <div
                    class="rate"
                    :class="[getSymbol(item.glYield) > 0 ? 'c1' : 'c3']"
                  >
                    {{ item.glYield.split('%')[0] }}
                    <span>%</span>
                  </div>
                </div>
                <div class="line"></div>
                <div class="right">
                  <div class="bag-name">{{ item.title }}</div>
                  <div class="author-name">{{ item.authorName }}</div>
                  <div class="des">
                    胜率:{{ item.selwinidx }} 最大回撤:{{ item.maxdrawidx }}
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
      <!-- 订阅热榜 -->
      <div class="subscription-wrap">
        <div class="title">
          <div class="left">
            <div class="icon"></div>
            <div class="font">订阅热榜</div>
          </div>
          <div style="margin-right: 20px" class="right">总收益</div>
        </div>
        <div class="subscription">
          <div
            v-for="(item, index) in jinNangList"
            :key="index"
            @click="goto(`/jinNang/${item.jinNangId}`)"
          >
            <div class="rank" :class="['rank' + (index + 1)]">
              {{ index > 2 ? index + 1 : '' }}
            </div>
            <div class="name">{{ item.title }}</div>
            <div
              class="total"
              :class="[getSymbol(item.glYield) > 0 ? 'c1' : 'c3']"
            >
              {{ item.glYield }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block5">
      <!-- 电视强档 -->
      <div class="title">
        <div class="left">
          <div class="icon"></div>
          <div class="font">电视强档</div>
        </div>
      </div>
      <div class="television-wrap">
        <div
          class="television"
          v-for="(item, index) in televisionList"
          :key="index"
          @click="goto(item.route)"
        >
          <div
            class="img"
            v-if="item.imageUrl"
            :style="{ backgroundImage: `url(${item.imageUrl})` }"
          ></div>
          <div class="sub-title">
            <div class="line"></div>
            <div class="font">{{ televisionListFont[index] }}</div>
            <div class="arrow"></div>
          </div>
          <div class="des">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import dayjs from 'dayjs'
import { getHotAuthors } from '@/api/account'
import {
  getAdvertisements,
  getRecommendSetList,
  getSilkBagList
  // getDianJinItems
} from '@/api/index'
import { getDianjinList } from '@/api/dianjin'
import { getHotSaledJinNangList } from '@/api/author'
import EveryBanner from '@/components/EveryBanner'

export default {
  name: 'Home',
  components: {
    swiper,
    swiperSlide,
    EveryBanner
  },
  data() {
    return {
      swiperOptions: {
        setWrapperSize: true,
        effect: 'coverflow',
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination'
        }
      },
      swiperOptionsHot: {
        setWrapperSize: true,
        watchOverflow: true,
        autoHeight: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionsBag: {
        setWrapperSize: true,
        watchOverflow: true,
        effect: 'coverflow',
        autoHeight: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      hotLecturers: [],
      bannerList: [],
      dianJinList: [],
      courseList: [],
      silkBagList: [],
      jinNangList: [],
      headList: [],
      televisionList: [],
      televisionListFont: ['今日股市', '谈股论金', '公司与行业']
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    swiperHot() {
      return this.$refs.swiperHot.swiper
    }
  },
  created() {
    this.getHotLecturer(20)
    this.getAdvert(
      'pc_home_banner,pc_home_mrtt,pc_home_jrgs,pc_home_tglj,pc_home_gshy'
    )
    this.getDianJinList()
    this.getRecommendSetList()
    this.getSilkBagList(8)
    this.getHotJinNangList()
    // this.getDianJinItems(1, 2)
    // this.getDianJinItems(2, 3)
  },
  methods: {
    dayjs,
    bagMouseEnter(index) {
      let swiper = ''
      if (index === 1) {
        swiper = this.swiperHot
      } else {
        swiper = this.swiper
      }
      swiper.navigation.$nextEl.removeClass('hide')
      swiper.navigation.$prevEl.removeClass('hide')
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    },
    bagMouseleave(index) {
      let swiper = ''
      if (index === 1) {
        swiper = this.swiperHot
      } else {
        swiper = this.swiper
      }
      swiper.navigation.$nextEl.addClass('hide')
      swiper.navigation.$prevEl.addClass('hide')
    },
    getNumber(length, divisor) {
      const count = Math.ceil(length / divisor)
      return count
    },
    async getHotLecturer(limit) {
      const detail = await getHotAuthors(limit)
      if (detail) {
        this.title = detail.title
        this.hotLecturers = detail.items
      }
    },
    async getAdvert(codes) {
      const detail = await getAdvertisements(codes)
      detail.forEach((item, index) => {
        if (item.code === 'pc_home_banner') {
          this.bannerList = item.list
        }
        if (item.code === 'pc_home_mrtt') {
          this.headList = item.list
        }
        if (item.code === 'pc_home_jrgs') {
          this.televisionList[0] = item.list[0] ? item.list[0] : []
        }
        if (item.code === 'pc_home_tglj') {
          this.televisionList[1] = item.list[0] ? item.list[0] : []
        }
        if (item.code === 'pc_home_gshy') {
          this.televisionList[2] = item.list[0] ? item.list[0] : []
        }
      })
    },
    async getDianJinList() {
      const data = await getDianjinList({
        direction: 0
      })
      if (data) {
        if (data.result.code === 0) {
          this.dianJinList = data.detail.list
        }
      }
    },
    async getRecommendSetList() {
      const detail = await getRecommendSetList(4)
      this.courseList = detail
    },
    async getSilkBagList(pageSize) {
      const data = await getSilkBagList(pageSize)
      this.silkBagList = data.list
    },
    async getHotJinNangList() {
      const data = await getHotSaledJinNangList()
      if (data) {
        this.jinNangList = data
      }
    },
    // async getDianJinItems(tag, limit) {
    //   const data = await getDianJinItems(tag, limit)
    //   if (data) {
    //     if (tag === 1) {
    //       this.headList = data
    //     } else {
    //       this.televisionList = data
    //     }
    //   }
    // },
    changeActiveTabsIndex(index) {
      this.swiper.slideTo(index)
    },
    goto(router) {
      const find = router.indexOf('http')
      if (find !== -1) {
        location.href = router
      } else {
        this.$router.push(router)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.block5 {
  padding: 50px 0 64px 0;
  .television-wrap {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .television {
      width: 382px;
      height: 276px;
      background-color: #ffffff;
      border: solid 1px #ebebeb;
      padding: 15px;
      box-sizing: border-box;
      cursor: pointer;
      &:nth-child(2) {
        margin: 0 30px;
      }
      .img {
        width: 353px;
        height: 168px;
        background: url('./images/index_32.b0b1d0fb.png') no-repeat;
        background-size: cover;
      }
      .des {
        color: #858585;
        font-size: 16px;
      }
    }
    .sub-title {
      display: flex;
      align-items: center;
      margin: 14px 0 19px 0;
      .line {
        width: 4px;
        height: 16px;
        background-color: #046bcc;
        margin-right: 10px;
      }
      .font {
        color: #262626;
        font-weight: bold;
        font-size: 16px;
      }
      .arrow {
        width: 8px;
        height: 14px;
        background: url('./images/arrow.png') no-repeat;
        background-size: cover;
        margin-left: 4px;
      }
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    .left {
      display: flex;
      align-items: center;
    }
    .icon {
      width: 20px;
      height: 20px;
      background: url('./images/dianshi.png') no-repeat;
      background-size: cover;
      margin-right: 10px;
    }
    .font {
      font-size: 20px;
      color: #046bcc;
    }
  }
}
.block3 {
  margin-top: 50px;
}
.block4 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 50px;
  .subscription-wrap {
    width: 332px;
    flex: none;
    .title {
      .icon {
        background-image: url('./images/dingyue.png');
      }
      .right {
        color: #262626;
      }
    }
    .subscription {
      padding: 15px;
      background-color: #fafafa;
      cursor: pointer;
      > div {
        display: flex;
        align-items: center;
        color: #262626;
        font-size: 16px;
        margin-bottom: 12px;
        &:last-child {
          margin: 0;
        }
        .rank {
          width: 22px;
          height: 24px;
          text-align: center;
          line-height: 24px;
        }
        .rank1 {
          background: url('./images/rank1.png') no-repeat;
          background-size: cover;
        }
        .rank2 {
          background: url('./images/rank2.png') no-repeat;
          background-size: cover;
        }
        .rank3 {
          background: url('./images/rank3.png') no-repeat;
          background-size: cover;
        }
        .name {
          flex: 1;
          margin-left: 15px;
        }
        .total {
          // color: #e64c2e;
        }
      }
    }
  }
  .silk-bag-wrap {
    width: 830px;
    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 8px;
      .silk-bag {
        cursor: pointer;
        width: 400px;
        height: 132px;
        background-color: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
        &:nth-child(3),
        &:nth-child(4) {
          margin-top: 30px;
        }
        display: flex;
        font-size: 14px;
        color: #858585;
        align-items: center;
        .left {
          width: 130px;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .font {
            color: #262626;
            font-size: 16px;
          }
          .rate {
            font-size: 20px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            margin-top: 8px;
            span {
              font-size: 16px;
            }
          }
        }
        .line {
          width: 1px;
          height: 40px;
          background-color: #ebebeb;
        }
        .right {
          padding-left: 30px;
          .bag-name {
            color: #262626;
            font-size: 16px;
            font-weight: bold;
          }
          .author-name {
            margin: 10px 0;
          }
        }
      }
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    .left {
      display: flex;
      align-items: center;
    }
    .icon {
      width: 20px;
      height: 20px;
      background: url('./images/jinnang.png') no-repeat;
      background-size: cover;
      margin-right: 10px;
    }
    .font {
      font-size: 20px;
      color: #046bcc;
    }
    .right {
      font-size: 14px;
      color: #858585;
      display: flex;
      align-items: center;
      cursor: pointer;
      .arrow {
        width: 8px;
        height: 14px;
        background: url('./images/arrow.png') no-repeat;
        background-size: cover;
        margin-left: 4px;
      }
    }
  }
}
.block2 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 50px;
  color: #262626;
  font-size: 16px;
  .hot-course-wrap {
    width: 332px;
    flex: none;
    > ul {
      background-color: #fafafa;
      padding-bottom: 20px;
      overflow: hidden;
    }
    .hot-course {
      display: flex;
      margin: 20px 20px 0;
      cursor: pointer;

      .head {
        width: 100px;
        height: 75px;
        background: #8e8e8e no-repeat center;
        background-size: cover;
      }

      .hot-course-right {
        flex: 1;
        padding-left: 15px;
      }

      .name {
        font-size: 16px;
        line-height: 40px;
        color: #262626;
      }

      .order-info {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding-top: 10px;

        .price {
          font-size: 14px;
          color: #e64c2e;
        }

        .count {
          font-size: 14px;
          color: #858585;
        }
      }
    }
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      .icon {
        width: 20px;
        height: 20px;
        background: url('./images/kecheng.png') no-repeat;
        background-size: cover;
        margin-right: 10px;
      }
    }
  }

  .solution-plate-wrap {
    margin-left: 36px;
  }
  .solution-plate {
    padding-top: 18px;
    width: 396px;
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      cursor: pointer;

      .dot {
        width: 4px;
        height: 4px;
        background-color: #cde1f5;
        margin-right: 10px;
      }
      .time {
        margin-right: 20px;
        flex: none;
      }
      .font {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .headline {
    padding-top: 18px;
    cursor: pointer;
    .img {
      width: 396px;
      height: 100px;
      background: url('./images/watch.png') no-repeat;
      background-size: cover;
      margin-bottom: 15px;
    }
    .font {
      margin-bottom: 30px;
    }
  }

  .sub-title {
    display: flex;
    align-items: center;
    font-weight: bold;
    width: 396px;
    height: 44px;
    background-color: #fafafa;
    .line {
      width: 4px;
      height: 16px;
      background-color: #046bcc;
      margin-right: 10px;
    }
  }
  .gold-pointing-wrap {
    width: 830px;
    .content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    .left {
      display: flex;
      align-items: center;
    }
    .icon {
      width: 20px;
      height: 20px;
      background: url('./images/dianjin.png') no-repeat;
      background-size: cover;
      margin-right: 10px;
    }
    .font {
      font-size: 20px;
      color: #046bcc;
    }
    .right {
      font-size: 14px;
      color: #858585;
      display: flex;
      align-items: center;
      cursor: pointer;
      .arrow {
        width: 8px;
        height: 14px;
        background: url('./images/arrow.png') no-repeat;
        background-size: cover;
        margin-left: 4px;
      }
    }
  }
}
.block1 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 30px;
  .banner-wrap {
    width: 830px;
    height: 256px;
    flex: 0 0 830px;
    .banner-img {
      width: 100%;
      height: 256px;
      cursor: pointer;
    }
  }
  .hot-people-wrap {
    width: 332px;
    flex: none;
    .content {
      padding: 14px 0;
      height: 224px;
      box-sizing: border-box;
      margin-top: 12px;
      background-color: #fafafa;
      display: flex;
      flex-wrap: wrap;
    }
    .people {
      flex: 0 0 33.33%;
      cursor: pointer;

      .head {
        width: 60px;
        height: 60px;
        background: no-repeat center;
        background-size: contain;
        border-radius: 50%;
        margin: 0 auto;
      }
      .name {
        font-size: 16px;
        color: #262626;
        text-align: center;
        margin: 10px 0 20px 0;
      }
    }
    .title {
      display: flex;
      align-items: center;
      .icon {
        width: 20px;
        height: 20px;
        background: url('./images/dg.png') no-repeat;
        background-size: cover;
        margin-right: 10px;
      }
      .font {
        font-size: 20px;
        color: #046bcc;
      }
    }
  }
}
</style>
<style lang="scss">
.index-page {
  .swiper-pagination,
  .swiper-pagination-bullets {
    left: auto !important;
    text-align: right;
    bottom: 6px !important;
    right: 20px;
    .swiper-pagination-bullet {
      bottom: 0;
      margin: 0px 5px;
      width: 6px;
      height: 6px;
      background-color: #ffffff;
      opacity: 0.5;
    }
    .swiper-pagination-bullet-active {
      width: 14px;
      height: 6px;
      background-color: #ffffff;
      border-radius: 3px;
      opacity: 1;
    }
  }
  .swiper-button-prev {
    width: 30px;
    height: 60px;
    background: url('./images/left.png') no-repeat;
    background-size: 100%;
    &.hide {
      display: none;
    }
  }
  .swiper-button-next {
    width: 30px;
    height: 60px;
    background: url('./images/right.png') no-repeat;
    background-size: 100%;
    &.hide {
      display: none;
    }
  }
}
</style>
